import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const postTrackEmailUser: DocumentNode = gql`
  mutation PostTrackEmailUser($externalId: String, $userAlias: UpdateTrackEmailUserAlias, $properties: JSON, $name: String, $time: DateTime) {
    updateTrackEmailUser(
      input: { events: { name: $name, userAlias: $userAlias, properties: $properties, externalId: $externalId, time: $time, updateExistingOnly: false } }
    ) {
      eventsProcessed
      message
      errors
    }
  }
`

export default postTrackEmailUser
